function getTheCookie(name) {
  let cookieArr = document.cookie.split(";");
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

function setTheCookie(name, value, days) {
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie =
    name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

$(document).ready(function () {
  // var Swipes = new Swiper(".switching-section-slider-container", {
  //   direction: "vertical", // Set the direction to vertical
  //   loop: true,
  //   slidesPerView: 3,
  //   spaceBetween: 15,
  //   slidesPerGroup: 1,
  //   slideToClickedSlide: false,
  //   centeredSlides: false,
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 3,
  //       slidesPerGroup: 1,
  //       spaceBetween: 15,
  //       centeredSlides: false,
  //     },
  //     576: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 15,
  //       slidesPerGroup: 1,
  //       centeredSlides: true,
  //     },
  //     320: {
  //       slidesPerView: 1.5,
  //       spaceBetween: 15,
  //       slidesPerGroup: 1,
  //       centeredSlides: true,
  //     },
  //   },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     type: "progressbar",
  //   },
  // });

  var $slider = $(".switching-section-slider");
  var $progressBar = $(".progress");
  var $progressBarLabel = $(".slider__label");
  var $pagination = $(".vertical-pagination");

  function updatePagination(currentSlide) {
    $pagination.find("button").removeClass("active");
    $pagination.find("button").eq(currentSlide).addClass("active");
  }

  $slider.on("init", function (event, slick) {
    for (var i = 0; i < slick.slideCount; i++) {
      $pagination.append("<button>" + (i + 1) + "</button>");
    }
    $pagination.on("click", "button", function () {
      var index = $(this).index();
      $slider.slick("slickGoTo", index);
    });
    updatePagination(slick.currentSlide);
  });

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    $progressBar
      .css("background-size", "100% " + calc + "%") // Update height percentage
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
    updatePagination(nextSlide);
  });

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 400,
    vertical: true, // Enable vertical mode
    verticalSwiping: true,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          vertical: false, // Switch to horizontal mode on mobile
          verticalSwiping: false,
          arrows: true, // Show arrows on mobile
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          vertical: false, // Switch to horizontal mode on mobile
          verticalSwiping: false,
          arrows: true, // Show arrows on mobile
          dots: true,
        },
      },
    ],
  });
  // Pricing table - mobile only slider
  var init = false;
  var pricingCardSwiper;
  function swiperCard() {
    if (window.innerWidth <= 991) {
      if (!init) {
        init = true;
        pricingCardSwiper = new Swiper(".cardSlider", {
          loop: true,
          slidesPerView: "1",
          spaceBetween: 0,
          grabCursor: true,
          keyboard: true,
          autoHeight: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        });
      }
    } else if (init) {
      pricingCardSwiper.destroy();
      init = false;
    }
  }
  swiperCard();
  window.addEventListener("resize", swiperCard);
});

//*************** Subscription Add to cart code *****************
function updateSelectedProduct() {
  // Get the checked product variant input
  let selectedVariant = $(
    ".single-product-section input[name='select-product-v2']:checked"
  );

  // Extract attributes from the selected input
  let productVariantId = selectedVariant.val();
  let productID = selectedVariant.attr("product-id");
  let sellingPlanID = selectedVariant.attr("selling-planID");
  let threeMonthProductId = selectedVariant.attr("three-month-product-id");
  let threeMonthVariantId = selectedVariant.attr("three-month-variant-id");
  let threesellingPlanID = selectedVariant.attr("three-month-selling-planID");

  // Update the attributes of the button
  $(".single-product-section .ajax-first-step-button").attr({
    "product-id": productID,
    "product-variant-id": productVariantId,
    "selling-planID": sellingPlanID,
    "three-month-product-id": threeMonthProductId,
    "three-month-product-variant-id": threeMonthVariantId,
    "three-month-selling-planID": threesellingPlanID,
  });
}

// function addToCartJS(sellingID, qty, variantID, btn) {
//   var xhr = new XMLHttpRequest();
//   var url = "/cart/add.js";
//   xhr.open("POST", url, true);
//   xhr.setRequestHeader("Content-Type", "application/json");
//   xhr.onreadystatechange = function () {
//     if (xhr.readyState === 4 && xhr.status === 200) {
//       btn.find(".button-loader").hide();
//       var parsedState = JSON.parse(xhr.responseText);
//       window.location = "/checkout";
//     }
//   };
//   var data = JSON.stringify({
//     selling_plan: sellingID,
//     quantity: qty,
//     id: variantID,
//   });
//   xhr.send(data);
// }

function addToCartJS(sellingID, qty, variantID, btn) {
  var data = [
    {
      id: 44170156441819,
      quantity: 1,
      selling_plan: "",
    },
    {
      id: variantID,
      quantity: qty,
      selling_plan: sellingID,
    },
  ];
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: data,
    },
    dataType: "json",
    success: function () {
      window.location = "/checkout";
      console.log("Data added successfully - selling_plan");
    },
    error: function (xhr, status, error) {
      console.error("Error adding data to cart:", error);
    },
  });
}

// Call the function on document ready
$(document).ready(function () {
  // First Step input on change event
  // $(document).on(
  //   "change",
  //   ".single-product-section input[name='select-product-v2']",
  //   function () {
  //     // updateSelectedProduct();
  //   }
  // );

  //first step button click event
  $(document).on("click", ".ajax-first-step-button", function () {
    $(".signle-product-part-1").removeClass("section-show").addClass("section-hide");
    $(".signle-product-part-2").addClass("section-show");

    $('.single-product-step').find('[data-step-index]').removeClass('active');
    $('.single-product-step').find('[data-step-index="2"]').addClass('active');
    // store selected product data in ajax-first-step-button
    updateSelectedProduct();
    
    let threeMonthProductID = $(this).attr("three-month-product-id");
    let threeMonthVariantID = $(this).attr("three-month-product-variant-id");
    let threeMonthSellingID = $(this).attr("three-month-selling-planid");

    $(".product-checkout-button .ajax-cart-button").attr(
      "product-id",
      threeMonthProductID
    );
    $(".product-checkout-button .ajax-cart-button").attr(
      "data-variant-id",
      threeMonthVariantID
    );
    $(".product-checkout-button .ajax-cart-button").attr(
      "selling-plan-id",
      threeMonthSellingID
    );
    $(this).parents(".signle-product-part-1").find(".single-select-images label").css("pointer-events", "none");

    //update featured image
    var featuredImageSrc = $(
      ".single-product-section input[name='select-product-v2']:checked"
    ).attr("image-src");
    var threeMonthFeaturedImageSrc = $(
      ".single-product-section input[name='select-product-v2']:checked"
    ).attr("three-month-image-src");
    if (featuredImageSrc != "undefined") {
      $(".single-product-image img").attr("src", featuredImageSrc);
      $(".single-select-product-image.v1 img").attr("src", featuredImageSrc);
    }

    // image default added
    var defaultImageSrc = $(".single-select-product-image.v2 img").attr("src");
    if (
      threeMonthFeaturedImageSrc !== undefined &&
      threeMonthFeaturedImageSrc !== "" &&
      threeMonthFeaturedImageSrc !== "blank"
    ) {
      $(".single-select-product-image.v2 img").attr(
        "src",
        threeMonthFeaturedImageSrc
      );
    } else {
      $(".single-select-product-image.v2 img").attr("src", defaultImageSrc);
    }

    // update description
    var oneMonthDescription = $(
      ".single-product-section input[name='select-product-v2']:checked"
    ).attr("one-month-description");
    var threeMonthDescription = $(
      ".single-product-section input[name='select-product-v2']:checked"
    ).attr("three-month-description");

    $(".step-two-one-month").html(oneMonthDescription);
    $(".step-two-three-month").html(threeMonthDescription);

    // change discount value
    var selelctedProductName = $(".single-product-section input[name='select-product-v2']:checked").attr("product-name");
    switch (true) {
      case selelctedProductName.includes("1"):
        $(".show-offer-text .discount-amount").html("$10");
        $(".dicount-amount").html("$10");
        break;
      case selelctedProductName.includes("2"):
        $(".show-offer-text .discount-amount").html("$20");
         $(".dicount-amount").html("$20");
        break;
      case selelctedProductName.includes("3"):
        $(".show-offer-text .discount-amount").html("$40");
         $(".dicount-amount").html("$40");
        break;
    }
  });

  //Second Step
  $(document).on(
    "change",
    "input[name='single-select-step-2-input']",
    function () {
      var $section = $(this).closest(".single-product-section");
      var $selectedVariant = $section.find(".ajax-first-step-button");
      var $ajaxVariantID = $section.find(".ajax-cart-button");
      var value = $(this).val();

      if (value == "1" || value == "3") {
        //Hide/show add-to-cart button on click 1 or 3 month
        $(".product-popup-button").toggle(value == "1");
        $(".product-checkout-button").toggle(value == "3");

        //Check if selected value is 1 month if yes then blank the value otherwise add 3month to find the attribute from the ajax-first-step-button
        var prefix = value == "1" ? "" : "three-month-";

        //Set sellingplanID on basis of selected value(1month/3month)
        $ajaxVariantID.attr(
          "data-variant-id",
          $selectedVariant.attr(prefix + "product-variant-id")
        );
        $ajaxVariantID.attr(
          "selling-plan-id",
          $selectedVariant.attr(prefix + "selling-planid")
        );
        $ajaxVariantID.attr(
          "product-id",
          $selectedVariant.attr(prefix + "product-id")
        );

        // Update the image source based on the selected value
        var imageSrc =
          value == "1"
            ? $(".single-select-product-image.v1 img").attr("src")
            : $(".single-select-product-image.v2 img").attr("src");

        $section.find(".single-product-image img").attr("src", imageSrc);
      }

      // Set or delete discount cookies based on the selected value and data-variant-id
      if (value == "3") {
        if ($ajaxVariantID.attr("data-variant-id") === "45727140708571") {
          setTheCookie("discount_code", "10OFFQuarterlyWith2Cats", 1);
        } else {
          setTheCookie("discount_code", "5OFFQuarterly", 1);
        }
      } else {
        deleteCookie("discount_code", "10OFFQuarterlyWith2Cats", 1);
        deleteCookie("discount_code", "5OFFQuarterly", 1);
      }
    }
  );

  //Trigger One cat popup button
  $(document).on("click", ".get-deal-button", function () {
    $(this)
      .parents(".single-product-section")
      .find(".ajax-cart-button")
      .trigger("click");
  });
  //AJAX Cart Event
  $(document).on("click", ".ajax-cart-button", function () {
    //Active checkout  step
    $(".single-product-imgae-number-cover").each(function (index, element) {
      $(element).removeClass("active"); // Remove active class from all elements
    });
    // Add active class to the last element
    $(".single-product-imgae-number-cover").last().addClass("active");

    let variantID = $(this).attr("data-variant-id");
    let sellingID = $(this).attr("selling-plan-id");

    var checkedValue = $(
      "input[name='single-select-step-2-input']:checked"
    ).val();
    if (checkedValue == "3") {
      if (
        $(this).attr("data-variant-id") === "45727139234011" &&
        !getTheCookie("OFFQuarterlyWith1Cat")
      ) {
        setTheCookie("discount_code", "OFFQuarterlyWith1Cat", 1);
        $(".show-offer-text p strong").html("$5");
      } else if (
        $(this).attr("data-variant-id") === "45727140708571" &&
        !getTheCookie("OFFQuarterlyWith2Cats")
      ) {
        setTheCookie("discount_code", "OFFQuarterlyWith2Cats", 1);
      } else if (
        $(this).attr("data-variant-id") === "45727142412507" &&
        !getTheCookie("OFFQuarterlyWith3Cats")
      ) {
        setTheCookie("discount_code", "OFFQuarterlyWith3Cats", 1);
      }
    }
    addToCartJS(sellingID, 1, variantID, $(this));
  });

  // shop page banner section step 2 JS
  $(".product-popup-button").hide();

  $(".product-popup-button").click(function () {
    $(".product-popup-part").show();
    $(".backdrop-layar").addClass("layar");
    var showImagePopup = $(".single-select-product-image.v2 img").attr("src");
    $(".product-popup-part .product-popup-image img").attr(
      "src",
      showImagePopup
    );
  });
  $(".backdrop-layar,.close-icon svg").click(function () {
    $(".product-popup-part").hide();
    $(".backdrop-layar").removeClass("layar");
  });

  // show loeader
  // Hide the loader when the page loads
  $(".button-loader").hide();
  $(".product-common-button.button").click(function () {
    var button = $(this);
    button.find(".button-loader").show();
    setTimeout(function () {
      button.find(".button-loader").hide();
    }, 1000); // 4000 milliseconds = 4 seconds
  });

  // Hide the loader when the page is shown (including when navigating back)
  $(window).on("pageshow", function () {
    $(".button-loader").hide();
  });

  $(document).on("click", ".ajax-subscription-trigger", function () {
    $("input[name='single-select-step-2-input']").each(function () {
      if ($(this).val() == "1") {
        $(this).prop("checked", false);
      } else if ($(this).val() == "3") {
        $(this).prop("checked", true).trigger("change");
        setTimeout(function () {
          $(".ajax-cart-button").trigger("click");
          // Set discount
          // var ajaxStoredVariantID = $('.ajax-cart-button').attr('data-variant-id');
          // if(ajaxStoredVariantID === '45727140708571'){
          //   setTheCookie("discount_code", "10OFFQuarterlyWith2Cats", 1);
          // }else{
          //   setTheCookie("discount_code", "10OFFQuarterly", 1);
          // }
        }, 100);
      }
    });
  });

  //clear cart on page refresh
  cartClear();

  // clear cart function
  function cartClear() {
    if (~window.location.href.indexOf("pages/shop") || $("body").hasClass("template-index")) {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function () {
          // Shopify.clear();
        },
        error: function (XMLHttpRequest, textStatus) {
          /* error code */
        },
      });
    }
  }

  // Function to handle height adjustment based on window width
  function adjustHeightBasedOnScreenWidth() {
    return $(window).width() <= 768 ? "58px" : "65px";
  }

  // Initial state: collapsed heights
  var collapsedHeight = adjustHeightBasedOnScreenWidth();

  var originalText = "Read More";
  var toggledText = "Read Less";

  // Set initial height and add a class for additional styling
  $(".accoridon-section .question-bx-cvr .net-cvr + div p:first-child")
    .css({
      height: collapsedHeight,
      overflow: "hidden",
    })
    .addClass("collapsed-paragraph");

  // Handle click event on net-cvr
  $(".net-cvr").click(function () {
    $(this).next("div").slideToggle();
    $(this).toggleClass("active");
    $(".net-cvr").not(this).removeClass("active").next("div").hide();

    if (!$(this).hasClass("active")) {
      let expandedDiv = $(this).closest(".faq-accodian").find(".expanded");
      expandedDiv.removeClass("expanded");
      expandedDiv.attr("style", "");

      // Set height to 58px on mobile
      if ($(window).width() <= 768) {
        expandedDiv.css("height", "58px");
      }
    }
  });

  // Handle click event on the toggle link
  $(
    ".accoridon-section .question-bx-cvr .net-cvr + div p:nth-child(2) a"
  ).click(function (e) {
    e.preventDefault();

    var $paragraph = $(this)
      .closest(".accoridon-section .question-bx-cvr .net-cvr + div")
      .find("p:first-child");
    if ($paragraph.hasClass("expanded")) {
      // Collapse
      $paragraph.animate({ height: collapsedHeight }, 500);
      $(this).text(originalText);
    } else {
      // Expand
      var expandedHeight = $paragraph[0].scrollHeight + "px"; // Get the actual height of the content
      $paragraph.animate({ height: expandedHeight }, 500);
      $(this).text(toggledText);
    }

    // Toggle the expanded class
    $paragraph.toggleClass("expanded");
  });

  // Handle window resize to ensure proper collapsed height on mobile
  $(window)
    .resize(function () {
      collapsedHeight = adjustHeightBasedOnScreenWidth();
      if (
        !$(
          ".accoridon-section .question-bx-cvr .net-cvr + div p:first-child"
        ).hasClass("expanded")
      ) {
        $(".collapsed-paragraph").css("height", collapsedHeight);
      }
    })
    .trigger("resize"); // Trigger resize event on load to set initial state

  $(document).on("click",".mobile-header-drawer .header-close-btn",function () {
      // $(".menu-drawer-container").removeClass("menu-opening");
      $(this).closest("header-drawer").find(".header__icon--menu").trigger("click");
    }
  );

  $(document).on("click", ".paw-steps-number", function() {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      if($(this).data("step-index") == "1"){
        $(this).closest(".single-product-content").find(".signle-product-part-2").removeClass("section-show").addClass("section-hide");
        $(this).closest(".single-product-content").find(".signle-product-part-1").removeClass("section-hide").addClass("section-show");
        $(this).closest(".single-product-content").find(".signle-product-part-1").find(".single-select-images label").css("pointer-events", "");
      }
      else if($(this).data("step-index") == "2"){
        $(this).closest(".single-product-content").find(".ajax-first-step-button").trigger("click");
      }
  });

  $(document).on("click",".needsclick:first",function(){
    $(this).hide();
  })
});

// page refresh code on back button click
window.addEventListener("pageshow", function (event) {
  var historyTraversal =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});

// fetch('/cart.json')
//           .then(response => response.json())
//           .then(data => {
//             var items = data.items;
//             var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
//             if (!foundMotivatorProduct) {
//               addMotivatorProduct(motivatorProductVariantID);
//             }
//           });
